<template>
  <div class="layout">
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.content {
  flex: 1;
  padding: 24px;
  background: #f8fafc;
  overflow-y: auto;
  height: 100vh;
}
</style>
